<ol *transloco="let t; read: 'onboarding'" class="nscp-onboarding-stepper__list">
  @for (step of steps(); track step.label; let index = $index; let first = $first) {
    @if (!first) {
      <li class="nscp-onboarding-stepper__connector" [class.nscp-onboarding-stepper__connector--filled]="step.status !== 'upcoming'" aria-hidden="true"></li>
    }
    <li
      class="nscp-onboarding-stepper__item"
      [class.nscp-onboarding-stepper__item--current]="step.status === 'current'"
      [class.nscp-onboarding-stepper__item--completed]="step.status === 'completed'"
    >
      <span class="nscp-onboarding-stepper__marker">
        @if (step.status === 'completed') {
          <sds-icon name="sdsCheck" size="xs" class="nscp-onboarding-stepper__marker-icon"></sds-icon>
        } @else {
          {{ index + 1 }}
        }
      </span>
      <span class="nscp-onboarding-stepper__text">
        <span class="nscp-onboarding-stepper__label">{{ step.label }}</span>
        <span class="nscp-onboarding-stepper__label-short">{{ step.labelShort }}</span>
        <span class="nscp-onboarding-stepper__description">{{ step.description }}</span>
      </span>
    </li>
  }
</ol>

<div *transloco="let t; read: 'onboarding'" class="nscp-onboarding-stepper__progress">
  <span class="nscp-onboarding-stepper__progress-label" data-testid="onboardingStepperProgress">{{
    t('stepper.stepOf', { current: currentStepNumber(), total: totalSteps() })
  }}</span>
  <div class="nscp-onboarding-stepper__progress-track">
    @for (step of steps(); track step.label; let index = $index) {
      <div
        class="nscp-onboarding-stepper__progress-segment"
        [class.nscp-onboarding-stepper__progress-segment--filled]="index <= currentIndex()"
        [class.nscp-onboarding-stepper__progress-segment--first]="index === 0"
      ></div>
    }
  </div>
</div>
